module.exports = __webpack_public_path__ + "img/image6.467faa5b.png";